export default "__VITE_ASSET__Dab3Ujcf__"